module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Readers Love ")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("Andrew Grey")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("An Isolated Range")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“Mr. Grey delivers a highly emotional story that captures the reader’s heart in one fell swoop. This is an author who is dedicated to his series, stories and characters. With each range story, you always find yourself drawn in, breathless until the very last page is read.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Dawn’s Reading Nook")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“Andrew Grey’s Range series just gets stronger with each new book and "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("An Isolated Range")]), _vm._v(" is perhaps the most amazing addition yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Scattered Thoughts and Rogue Words")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("An Isolated Range")]), _vm._v(" is a story not of human triumphs but also of sadness and death. This is an author who balances both so well that the reader is left speechless after that last page is read.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Love Romances and More")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The Fight Within")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I loved this book, these characters, and this story. Get it today. Read. Understand and through understanding, enjoy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Mrs. Condit & Friends Read Books")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This is a story that is rich in detail, delving into the Native American culture and also sharing the suffering that the Native American’s still face today.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This was a very powerful read.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Live your Life, Buy the Book")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4a8b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0